module.exports = __webpack_public_path__ + "img/bzhan.2a829bbd.png";